import {HTMLPrinter} from "@k/global/htmlprinter";
import {AnfragenController, HelpAnfrageParameters} from "@k/js/controllerModules/anfragenController";
import {owayoModelWrapper} from "@km/js/initMobile";
import globalsObject from "@k/js/globalsObject";
import type {BasicContactFormData} from "@km/components/popups/BasicContactFormData";
import {displayAcknowledgePopup} from "@km/components/popups/ConfirmOrConfirmCancelDialog";


export function  sendGetHelpForm(params:HelpAnfrageParameters, store, i18n) {
    return new Promise<void>(resolve => {
        const p = HTMLPrinter;
        AnfragenController.getHelp(params, owayoModelWrapper, store.getters.getInfoFromGetParameters, globalsObject.owayoJSViewer.webGLBrowserLimits)
            .then(() => {
                displayAcknowledgePopup(
                    i18n.t("konf_messageSent"),
                    i18n.t("Kontakt_Okay") + p.collection(p.br, p.strong(i18n.t("konf_warnAboutSpamFolder")))
            ).then(()=>resolve())})
    })
}

export function getHelpAnfrageParameters(formdata:BasicContactFormData, typ, category):HelpAnfrageParameters {
    return {
        typ: typ,
        category: category,
        description: formdata.message.value.trim(),
        contactEmail: formdata.email.value.trim(),
        contactTelefon: formdata.telefon.value.trim(),
        nachname: ([formdata.vorname.value, formdata.nachname.value].join(" ")).trim(),
        ansprechpartner: ([formdata.vorname.value, formdata.nachname.value].join(" ")).trim()
    }
}
